var success = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-05-02 15:08:27',
    type: 'SMS_CODE',
    data: {
        loanId: 12345,
        method: 'sms',
        smsId: 12345223,
        phoneNumber: '111111111',
        attempt: 2,
    },
};
var errorTooManyAttempts = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-05-02 15:08:27',
    type: 'SMS_CODE',
    data: {
        parameter: 'loanId',
        errorDescription: 'Too many attempts',
    },
};
export var loanSignMock = {
    success: success,
    error: {
        tooManyAttempts: errorTooManyAttempts,
    },
};
